import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetShipmentCategoryRequestParams {
  CustomerKey: string;
  CategoryId: string;
}

const getShipmentCategoryAPI = (params: GetShipmentCategoryRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShipmentCategory`,
    method: 'get',
    params,
  });
};

export type ShipmentCategoryResponse = {
  text: string;
  value: string; // '233'
}[];

export const fetchShipmentCategory = async (
  params: GetShipmentCategoryRequestParams,
): Promise<ShipmentCategoryResponse> => {
  const response: AxiosResponse<ShipmentCategoryResponse> = await getShipmentCategoryAPI(params);
  return response.data;
};
